import { Dispatch } from 'redux';
import service from 'services';
import localConfigs from 'utils/configs';
import { slice } from './slice';

const setConfigs = (idUser: number, idProgram: number) => async (dispatch: Dispatch) => {
  try {
    const { data } = await service.getConfig(idUser, idProgram);
    const configs = { ...localConfigs[idProgram], ...data };
    dispatch(slice.actions.setConfigs(configs));
  } catch (e) {
    console.error(e);
  }
};

const setConfigurationsByCompanies = (idUser: number, idProgram: number) => async (dispatch: Dispatch) => {
  try {
    const { data } = await service.getConfigurationsByCompanies(idUser, idProgram);
    dispatch(slice.actions.setCompanies(data));
  } catch (e) {
    console.error(e);
  }
};

const setConfigurationsByCompaniesDocTypeUser = () => async (dispatch: Dispatch) => {
  try {
    const { data } = await service.getCompaniesWithDocTypeAndUser();
    dispatch(slice.actions.setCompaniesDocTypeUser(data));
  } catch (e) {
    console.error(e);
  }
};

const appActions = {
  ...slice.actions,
  setConfigs,
  setConfigurationsByCompanies,
  setConfigurationsByCompaniesDocTypeUser,
};

export default appActions;
